import { UserProfile } from './types';
import appClient from '../../common/services/AppClient';
import { ResponseData } from '../../common/services/AppClient';
import { UserModel } from '../types/UserModel';
import { UserInfo } from '../types/UserInfo';
import { endpoints } from '../../../config';

export default class UserProfileService {
    async getUserProfile(): Promise<UserProfile> {
        const result = await appClient.get<UserProfile>(endpoints.usersUrl + 'userprofile');
        if (result.isErr()) {
            throw result.error;
        }

        return result.value;
    }

    updateUserProfile(data: FormData) {
        const url = endpoints.usersUrl + 'userProfile';
        return appClient.post(url, data);
    }

    async getAvatarIcon(fileId: string) {
        const url = `${endpoints.usersUrl}userProfile/icon/${fileId}`;
        const resp = await appClient.get<Blob | undefined>(url, 'blob');
        return resp.unwrapOr(undefined);
    }

    getUserByName(name: string) {
        const url = `${endpoints.usersUrl}${name}`;
        return appClient.get<UserModel>(url);
    }

    resetPassword(password: string) {
        const data = { password };
        const url = endpoints.usersUrl + 'userProfile/password';
        return appClient.post<boolean>(url, data);
    }

    async changePassword(newPassword: string, oldPassword: string): Promise<ResponseData> {
        const data = { oldPassword, newPassword };
        const url = endpoints.usersUrl + 'userProfile/password_change';
        return appClient.postRaw(url, data);
    }

    async getUserInfo() {
        const url = `${endpoints.usersUrl}userInfo`;
        const resp = await appClient.get<UserInfo>(url);
        const userInfo = resp.unwrapOr({} as UserInfo);
        return userInfo;
    }
}
